import { TOGGLE_EDUCATION_BAR } from "../action_types/educationBar_action_types";

export const toggleEducationBar = (isOpen: boolean, article?: FixmeType) => {
    return {
        type: TOGGLE_EDUCATION_BAR,
        isOpen,
        article,
    };
};
